import { NAMESPACE } from "../constants";
export const highContrastStyle = (truthyCSS, falsyCss = "") => ({ theme }) => theme[NAMESPACE].features?.highContrast || theme[NAMESPACE].name === "alchemyContrast" ? truthyCSS : falsyCss;
